document.addEventListener("DOMContentLoaded", () => {
    const handleChangeChildVariant = () => {
        let completedBundle = 0;
        document
            .querySelectorAll(".childProductValue:checked")
            .forEach((value, index) => {
                const jsonData = JSON.parse(value.value) ?? null;
                if (jsonData.variantid == "selectVariant") {
                    completedBundle++;
                } else {
                    const currentSelectBox = value.closest(
                        ".individual-variant-select-box__current"
                    );
                    if (currentSelectBox) {
                        const valueSelect = currentSelectBox.querySelector(
                            ".individual-variant-select-box__input-text"
                        );
                        const icon = currentSelectBox.querySelector(
                            ".individual-variant-select-box__icon"
                        );
                        const iconCheck = currentSelectBox.querySelector(
                            ".individual-variant-select-box__icon-check"
                        );
                        valueSelect.classList.add("selectedVariant");
                        icon.style.display = "none";
                        iconCheck.style.display = "inline";
                    }
                }
            });
        if (completedBundle == 0) {
            document
                .querySelectorAll(".add-to-cart-button")
                .forEach((button) => {
                    button.removeAttribute("disabled");
                    button.innerText = "Add to Cart";
                });
        }
    };
    const handleFixedBundleClick = () => {
        const showFlag = document.querySelectorAll(
            ".fixed-bundle-checkbox:checked"
        ).length;
        document
            .querySelectorAll(".fixed-bundle-childProducts")
            .forEach((item) => {
                showFlag
                    ? item.classList.add("fixed-bundle-hidden")
                    : item.classList.remove("fixed-bundle-hidden");
            });
        document.querySelectorAll(".hiddeInfo").forEach((item) => {
            showFlag ? item.innerText("Show") : item.innerText("Hide");
        });
    };
    const handleClickShowMore = (e) => {
        const el = e.currentTarget;
        const showFlag = el.classList.contains("fixed-bundle-show-less");
        showFlag
            ? el.classList.remove("fixed-bundle-show-less")
            : el.classList.add("fixed-bundle-show-less");
        el.querySelector("span").innerText = showFlag ? "more" : "less";
        document
            .querySelectorAll(".fixed-bundle-main-selected-variants .fixed-bundle-carousel")
            .forEach((carouselContainer, carouselContainerIndex) => {
                if (carouselContainerIndex < 1) return 0;
                showFlag
                    ? carouselContainer.classList.remove("carousel-active")
                    : carouselContainer.classList.add("carousel-active");
            });
    };
    const handleQuantityChange = (e) => {
        const el = e.currentTarget;
        document
            .querySelectorAll(".quantity__input-bundles")
            .forEach((value) => {
                value.value = el.value;
            });
    };
const handleSubmitProduct = (e) => {
    const form = e.target.closest("form");

    if (!form) return;

    const inputValues = document.querySelectorAll(".childProductValue:checked");
    const bundleImage = document.querySelector(".bundleImage")?.value ?? "";
    const preselectedProduct =
        document.querySelector(".preselectedProduct")?.value ?? null;

    const quantitiesArray = [];

    const jsonValues = uniqueJSON(
        [...inputValues].flatMap((value) => JSON.parse(value.value))
    );

    const jsonValuesSorted = sortJSON(jsonValues, "childproductname", "asc");

    jsonValuesSorted.forEach((inputValue) => {
        quantitiesArray.push({
            id: inputValue.variantid,
            quantity: inputValue.quantity || 1,
        });
    });

    if (preselectedProduct) {
        quantitiesArray.push({
            id: preselectedProduct,
            quantity: 1,
            isPreselectedProduct: true,
        });
    }

    // 🔥 Remove old inputs (important to avoid duplicates)
    form.querySelectorAll(".bundle-prop").forEach(el => el.remove());

    // ✅ Add bundle flag
    const bundleFlag = document.createElement("input");
    bundleFlag.type = "hidden";
    bundleFlag.name = "properties[_bundleproduct]";
    bundleFlag.value = "true";
    bundleFlag.classList.add("bundle-prop");

    // ✅ Add quantities array
    const quantitiesInput = document.createElement("input");
    quantitiesInput.type = "hidden";
    quantitiesInput.name = "properties[_quantitiesarray]";
    quantitiesInput.value = JSON.stringify(quantitiesArray);
    quantitiesInput.classList.add("bundle-prop");

    // ✅ Add image
    const imageInput = document.createElement("input");
    imageInput.type = "hidden";
    imageInput.name = "properties[_bundleimage]";
    imageInput.value = bundleImage;
    imageInput.classList.add("bundle-prop");

    form.appendChild(bundleFlag);
    form.appendChild(quantitiesInput);
    form.appendChild(imageInput);
};
    function init_bundle() {
        document
            .querySelectorAll(".childProductValue:checked")
           .forEach((value) => {
                const json = JSON.parse(value.value);
                const isOutOfStock = value.getAttribute('data-tag') === 'oos-tag';
                const childAvailable = value.getAttribute('data-child-available') || "";
                const isChildSoldOut = childAvailable.includes('childSoldOut');
              
              document.querySelectorAll(".add-to-cart-button").forEach((button) => {
                if (isOutOfStock || (json.variantid == "selectVariant" && isChildSoldOut)) {
                    button.setAttribute("disabled", "");
                    button.innerText = "Sold Out";
                } else if (json.variantid == "selectVariant") {
                    button.setAttribute("disabled", "");
                    button.innerText = "COMPLETE BUNDLE";
                }
            });
          });
    }
    document.querySelectorAll(".childProductValue").forEach((item) => {
        item.addEventListener("change", handleChangeChildVariant);
    });
    document.querySelectorAll(".fixed-bundle-checkbox").forEach((item) => {
        item.addEventListener("click", handleFixedBundleClick);
    });
    document.querySelectorAll(".fixed-bundle-show-more").forEach((item) => {
        item.addEventListener("click", handleClickShowMore);
    });
    document.querySelectorAll(".quantity__input-bundles").forEach((item) => {
        item.addEventListener("change", handleQuantityChange);
    });
    document.querySelectorAll(".add-to-cart-button").forEach((item) => {
        item.addEventListener("click", handleSubmitProduct);
    });
    init_bundle();
});

function calculate_discounted_prices(child_prices, bundle_price) {
    child_prices = child_prices.map((price) => makeDecimal(price));
    bundle_price = makeDecimal(bundle_price);

    const total_child_price = child_prices.reduce(
        (acc, price) => acc.plus(price),
        new Decimal(0)
    );

    const discount_factor = new Decimal(bundle_price).div(total_child_price);

    const discounted_prices = [];
    for (let i = 0; i < child_prices.length - 1; i++) {
        discounted_prices.push(
            Number(
                new Decimal(child_prices[i]).times(discount_factor).toFixed(0)
            )
        );
    }

    discounted_prices.push(
        Number(
            new Decimal(bundle_price)
                .minus(
                    discounted_prices.reduce(
                        (acc, price) => acc.plus(price),
                        new Decimal(0)
                    )
                )
                .toFixed(2)
        )
    );
    return discounted_prices;
}
